var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import { Map } from 'immutable';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import EntityView from "../EntityView";
import { Loader } from "../../components/Elements/Loader";
import { actions } from "../../BasicReducer";
import { t } from "../../I18N";
import { ErrorFallback } from "../../V2/Components/ErrorHandling";
import { PDFView } from "../PDFView";

class EntityViewerComponent extends Component {
  constructor(props, context) {
    super(props, context);
    props.setSidepanelTrigger();
  }

  render() {
    const { entity, notFound } = this.props;

    if (!entity.get('_id')) {
      if (notFound) {
        return (/*#__PURE__*/
          _jsx(ErrorFallback, { error: { status: 404, message: t('System', 'Not Found', null, false) } }));

      }
      return /*#__PURE__*/_jsx(Loader, {});
    }

    return entity.get('defaultDoc') ? /*#__PURE__*/React.createElement(PDFView, this.props) : /*#__PURE__*/React.createElement(EntityView, this.props);
  }
}

EntityViewerComponent.defaultProps = {
  notFound: false
};







const setSidepanelTrigger = () => actions.set('library.sidepanel.view', 'entity');

const mapStateToProps = (state) => {
  const entity = state.documentViewer.doc.get('_id') ?
  state.documentViewer.doc :
  state.entityView.entity;

  const notFound = state.entityView.uiState.get('tab') === '404';
  return {
    entity,
    notFound
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setSidepanelTrigger
    },
    dispatch
  );
}

const ViewerComponent = connect(mapStateToProps, mapDispatchToProps)(EntityViewerComponent);

export { ViewerComponent };